import { useEffect } from "react";

export const VillaininLove = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div
                className="modal"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflowY: "auto", // Enable scrolling for the modal
                    zIndex: 1050,

                }}
            >
                <div
                    className="modal-content"
                    style={{
                        padding: "20px",
                        background: "#fff",
                        borderRadius: "8px",
                        maxWidth: "500px",
                        width: "95%",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                        maxHeight: "95vh", // Limit the modal height to viewport
                        overflowY: "auto", // Enable content scrolling within the modal
                    }}
                >
                    <div className="img-fluid mb-4">
                        <picture>
                            <img
                                src="/media/poemseng/villain-in-love.jpg"
                                alt=" Villain in Love | Lone Wolf writes "
                                style={{
                                    width: "100%",
                                    height: "18rem",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    backgroundColor: "gray",
                                }}
                            />
                        </picture>
                    </div>

                    <h2 style={{ textAlign: "center", color:"red" }}>Villain in Love</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        Since the beginning, I admired the villains,<br />
                        No matter how strong or mighty, was the hero;<br />
                        in every climax, the hero was the number one,<br />
                        Where the villain always was the deutero.<br />
                        <br />
                        Some actions made people think, I'm an antihero,<br />
                        But, I always felt myself as a sub-zero;<br />
                        I've been in emotional debt forever,<br />
                        But you always were my happiness giro.<br />
                        <br />
                        Even when we were having troubles,<br />
                        You always made my life hiro*;<br />
                        I might be a villain in my story,<br />
                        But In yours, I want to be a superhero.<br />
                        <br />
                    </p>
                    <hr />

                    *here, "hiro" is japanese for "prosperous"

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
